import { AgsAnimateBehaviour } from "ags/behaviours/ags-animate-behaviour";
import { AgsBorderHighlightBehaviour } from "ags/behaviours/ags-border-highlight";
import { MatrixFactory } from "slotworks/components/factories/matrix-factory";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { SpinStageEvents } from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";
import { TintDimSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/tint-dim-symbol-behaviour";
import { slotDefinition } from "slotworks/model/slot-definition";

export class AgsMatrixFactory extends MatrixFactory {

    constructor() {
        super();

        this.spinSpeed = 0.02;

        const minStopDistance = slotDefinition.matrixGrid.reduce((max, current) => current > max ? current : max, 0) + 1;

        this.spinStages = [
            {
                name: "accelerate",
                s: -1,
                u: 0,
                v: -this.spinSpeed,
                events: [
                    {
                        name: SpinStageEvents.START,
                        delay: 50
                    }
                ]
            },
            {
                name: "minRepeat",
                s: -1,
                u: - this.spinSpeed,
                v: - this.spinSpeed
            },
            {
                name: "repeat",
                s: -1,
                u: -this.spinSpeed,
                v: -this.spinSpeed
            },
            {
                name: "stop",
                s: -minStopDistance,
                u: -this.spinSpeed,
                v: -this.spinSpeed,
                events: [
                    {
                        name: SpinStageEvents.STOP,
                        delay: 250
                    }
                ]
            },
            {
                name: "land",
                s: 0,
                t: 0
            },
            {
                name: "fullstop",
                s: -0.35,
                u: -0.01,
                v: 0
            },
            {
                name: "complete",
                s: 0.35,
                t: 220,
                easing: "Quadratic.Out",
                events: [
                    {
                        name: SpinStageEvents.SKIP,
                        delay: 0
                    }
                ]
            }
        ];

        this.skipStages = [
            {
                name: "stop",
                s: -minStopDistance,
                u: -this.spinSpeed,
                v: -this.spinSpeed,
                events: [
                    {
                        name: SpinStageEvents.STOP,
                        delay: 0
                    },
                    {
                        name: SpinStageEvents.SKIP,
                        delay: 0
                    }
                ]
            },
            {
                name: "land",
                s: 0,
                t: 0
            },
            {
                name: "fullstopskip",
                s: -0.5,
                u: -this.spinSpeed,
                v: 0
            },
            {
                name: "complete",
                s: 0.5,
                t: 200
            }
        ];

        this.anticipationStages = [
            {
                name: "anticipate",
                s: -minStopDistance,
                u: -this.spinSpeed,
                v: -0.03
            },
            {
                name: "tease",
                s: -34,
                u: -this.spinSpeed,
                v: -this.spinSpeed
            },
            {
                name: "stop",
                s: -minStopDistance,
                u: -this.spinSpeed,
                v: -0.03
            },
            {
                name: "land",
                s: 0,
                t: 0
            },
            {
                name: "fullstop",
                s: -0.5,
                u: -this.spinSpeed,
                v: 0
            },
            {
                name: "complete",
                s: 0.5,
                t: 150,
                events: [
                    {
                        name: SpinStageEvents.STOP,
                        delay: 100
                    },
                    {
                        name: SpinStageEvents.SKIP,
                        delay: 0
                    }
                ]
            }
        ];
    }

    protected addSymbolBehaviours(matrix: AbstractMatrixComponent) {
        matrix.addDefaultSymbolBehaviour((symbol) => new TintDimSymbolBehaviour(symbol));
        matrix.addDefaultSymbolBehaviour((symbol) => new AgsAnimateBehaviour(symbol));
        matrix.addDefaultSymbolBehaviour((symbol) => new AgsBorderHighlightBehaviour(symbol));
    }
}
